/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-lines */
import {
  Autocomplete,
  Box,
  Button,
  createFilterOptions,
  Grid,
  InputLabel,
  OutlinedInput,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import LeadGenerationContext from '../../context/LeadGenerationContext';
import { AnotherBankAccountPlaidStyles as classes } from './AnotherBankAccountPlaidStyles';
import FailImage from '../../images/failIconPlaid.svg';
import SuccessImage from '../../images/successIconPlaid.svg';
import PendingImage from '../../images/pendingIconPlaid.svg';
import PlaidImage from '../../images/plaidImg.svg';
import PlaidImageDark from '../../images/Plaid Logo Dark.png';

import StatementUpload from '../Sidebar/StatementUpload';
import { productMapping } from '../../services/productMapping';
import { commonUtility, commonUtilityValueReturn } from '../LeadGeneration/UtilityFunctions';
import {
  ACCOUNT_NUM,
  ACCOUNT_NUMBER,
  ACCOUNT_TYPE,
  BANK,
  BANK_NAME,
  DEPOSIT_AMOUNT,
  ELITE_ACCOUNT_EN,
  EN,
  ENTER_ACCOUNT_NUMBER,
  ENTER_ROUTING_NUMBER,
  ENTER_TRANSIT_NUMBER,
  FUNDING_DEPOSIT_QUESTION,
  FUND_UPLOAD_VOID_CHECK,
  INVALID_FORMAT_ERR,
  MANDATORY_FIELD_ERR,
  MINIMUM_DEPOSIT,
  MINIMUM_DEPOSIT_AMOUNT,
  MIN_DEPOSIT_ERR,
  OTHER,
  RADIO_COLOR,
  REQUIRED,
  ROUTING_NUMBER,
  SOURCE_OF_FUNDS,
  SOURCE_OF_FUNDS_PLACEHOLDER,
  TRANSIT_NUMBER,
  TYPE_OF_ACCOUNT,
  VERIFICATION_INPROGRESS,
  VERIFICATION_PENDING,
} from '../../constants';
import { dgiMapping } from '../../services/dgiMapping';
import { CustomInput } from '../LeadGeneration/CustomInput/CustomInput';
import { CustomSelect } from '../LeadGeneration/CustomSelect/CustomSelect';
import { CustomSelectAccount } from '../LeadGeneration/CustomSelect/CustomSelectAccount';
import {
  commonTernary,
  isBundle,
  isCDIraproduct,
  isCDproduct,
  isPlaidProduct,
  nbrToCurrencyFormat,
} from '../commonCode';
import { CommonStyles } from '../LeadGeneration/CommonStyles';
import { SourceOfFundsList } from '../LeadGeneration/CertificateOfDeposit/SourceOfFundsList';
import {
  DownArrowIcon,
  GreenTickFill,
  ThumbsUpWhite,
  VerificationPendingIcon,
} from '../../images/svg/CustomizedSVG';
import { LayoutStyles as bundleClasses } from '../Bundle/LayoutStyles';
import DocumentUploadSidebar from '../Sidebar/DocumentUploadSidebar';
import BusinessDragDropUploadACT from '../CommercialDeposit/DragDropFiles/BusinessDragDropUploadACT';
import LinearWithValueLabel from '../Bundle/LinearProgress';
import DocChecklist from '../CommercialDeposit/DragDropFiles/DocChecklist';

// eslint-disable-next-line react/prop-types
const AnotherBankAccountPlaid = ({ open, ready }) => {
  const { t } = useTranslation();
  const themes = useTheme();
  const isMobile = useMediaQuery(themes?.breakpoints?.between('960', '1030'), {
    defaultMatches: true,
  });
  const [banks, setBanks] = useState([]);
  const [bankTransitNumbers, setBankTransitNumbers] = useState([]);
  const leadGenerationContext = useContext(LeadGenerationContext);

  const {
    singleAccDis,
    setSingleAccDis,
    fundData,
    productName,
    fundDataErrors,
    setFundData,
    setFundDataErrors,
    setIsFundingScreenDirty,
    setIsEdeliveryScreenDirty,
    plaidDetails,
    statementDocumentId,
    statementUploadStatus,
    bankDetails,
    plaidAccNoLinked,
    setPlaidSuccessDetails,
    plaidRetry,
    setPlaidAccNoLinked,
    statementUploadLoading,
    cdFlowOffers,
    language,
    theme,
    isLightTheme,
    productDataIRA,
    flowTypeETB,
  } = leadGenerationContext;
  const commonClass = CommonStyles(theme);
  const gridSizeForBundle = isBundle(productName) ? 12 : 6;
  const fieldRightPadding = !isBundle(productName) && classes.field_padding_right;
  const isVerificationPending =
    plaidDetails?.remarks === 'pending_manual_verification' && plaidDetails?.status === 'Success';
  const isPlaidSuccess = plaidDetails?.status === 'Success' && !plaidDetails?.remarks;

  const plaidAccountDet = plaidAccNoLinked?.length > 0;

  const filterOptionsEmp = createFilterOptions({
    matchFrom: 'start',
    stringify: language === EN ? (option) => option.en : (option) => option.es,
  });
  const getAmountByAccountNumber = (selectedAccId) => {
    const selectedAccount = plaidAccNoLinked?.find((account) => account.Id === selectedAccId);
    return selectedAccount ? selectedAccount.Balance : null;
  };
  useEffect(() => {
    if (fundData.transitNumber?.length >= 1 && fundData?.bank === OTHER) {
      if (/^0+$/.test(fundData.transitNumber) && fundData.transitNumber?.length === 9) {
        // leadGenerationContext.setFundData((prevState) => ({
        //   ...prevState,
        //   transitNumber: numberString.padStart(9, '0'),
        // }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '* Invalid Format',
        }));
      } else {
        // leadGenerationContext.setFundData((prevState) => ({
        //   ...prevState,
        //   transitNumber: numberString.padStart(9, '0'),
        // }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    }
  }, [fundData.transitNumber]);

  const validateDepositAmtCD = (depositAmt) => {
    if (
      fundData.accountNumber &&
      plaidDetails?.status === 'Success' &&
      isPlaidProduct(productName) &&
      depositAmt > getAmountByAccountNumber(fundData.Id)
    ) {
      const updateAccountDetailsPlaid = plaidAccNoLinked?.map((option) => {
        let isDepositeGreaterThanBalanceAnother;
        if (fundData.Id) {
          isDepositeGreaterThanBalanceAnother = option.Id === fundData.Id;
        }
        return { ...option, isDepositeGreaterThanBalanceAnother };
      });
      setPlaidAccNoLinked(updateAccountDetailsPlaid);

      setFundData({ ...fundData, depositAmount: depositAmt });
      setFundDataErrors({
        ...fundDataErrors,
        depositAmount:
          '* Please review the deposit amount entered on CD offer screen as it is more than the available balance on this account',
      });
    } else {
      const resetDisableCondition = plaidAccNoLinked?.map((item) => ({
        ...item,
        isDepositeGreaterThanBalanceAnother: false,
      }));
      setPlaidAccNoLinked(resetDisableCondition);

      setFundDataErrors((prevState) => ({
        ...prevState,
        depositAmount: '',
      }));
    }
  };

  const handleBlurRouting = (e) => {
    const numberString = e.target.value.toString();
    if (
      (e.target.value >= 1 || fundData.transitNumber.length >= 1) &&
      fundData?.bank === OTHER &&
      fundData.transitNumber !== OTHER
    ) {
      leadGenerationContext.setInterestPaymentMethod((prevState) => ({
        ...prevState,
        transitNumber: numberString.padStart(9, '0'),
      }));
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setFundData((prevState) => ({
          ...prevState,
          transitNumber: numberString,
        }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundData((prevState) => ({
          ...prevState,
          transitNumber: numberString.padStart(9, '0'),
        }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else if (
      (e.target.value >= 1 || fundData?.customTransitNumber?.length >= 1) &&
      fundData?.transitNumber === OTHER
    ) {
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setFundData((prevState) => ({
          ...prevState,
          customTransitNumber: numberString,
        }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundData((prevState) => ({
          ...prevState,
          customTransitNumber: numberString.padStart(9, '0'),
        }));
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: '',
        }));
      }
    }
  };
  useEffect(() => {
    if (plaidDetails?.status === 'Success') {
      const updateAccountDetailsPlaid = plaidAccNoLinked?.map((option) => {
        let isDepositeGreaterDisableAll;

        if (fundData?.depositAmount) {
          // if (productMapping(productName) === 'Personal') {
          //   isDepositeGreaterDisableAll = option.Balance < parseInt(fundData?.depositAmount, 10);
          // } else {
          isDepositeGreaterDisableAll =
            option.Balance < fundData?.depositAmount?.toString().replace(',', '');
          //  }
        }
        return { ...option, isDepositeGreaterDisableAll };
      });
      setPlaidAccNoLinked(updateAccountDetailsPlaid);
    }
    // if (productMapping(productName) === 'Personal') {
    //   validateDepositAmtCD(parseInt(cdFlowOffers?.depositAmount, 10));
    // }
  }, [fundData.depositAmount, plaidAccountDet]);

  const depositAmountCall = (e) => {
    if (e.target.value?.match(/^\d*$/) && e.target.value?.length < 7) {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      if (isPlaidProduct(productName)) {
        if (
          parseInt(e.target.value, 10) >= parseInt(fundData?.minDepositAmount, 10) &&
          parseInt(e.target.value, 10) <= parseInt(5000, 10)
        ) {
          if (
            fundData.accountNumber &&
            plaidDetails?.status === 'Success' &&
            isPlaidProduct(productName) &&
            e.target.value > getAmountByAccountNumber(fundData.Id)
          ) {
            const updateAccountDetailsPlaid = plaidAccNoLinked?.map((option) => {
              let isDepositeGreaterThanBalanceAnother;
              if (fundData.Id) {
                isDepositeGreaterThanBalanceAnother = option.Id === fundData.Id;
              }
              return { ...option, isDepositeGreaterThanBalanceAnother };
            });
            setPlaidAccNoLinked(updateAccountDetailsPlaid);

            setFundData({ ...fundData, [e.target.name]: e.target.value });
            setFundDataErrors({
              ...fundDataErrors,
              [e.target.name]:
                '* Please review the deposit amount entered as it is more than the available balance on this account',
            });
          } else {
            const resetDisableCondition = plaidAccNoLinked?.map((item) => ({
              ...item,
              isDepositeGreaterThanBalanceAnother: false,
            }));
            setPlaidAccNoLinked(resetDisableCondition);

            setFundDataErrors((prevState) => ({
              ...prevState,
              [e.target.name]: '',
            }));
          }
        } else if (parseInt(e.target.value, 10) > parseInt(5000, 10)) {
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: 'The maximum limit for initial deposit is $5,000.',
          }));
        } else {
          const resetDisableCondition = plaidAccNoLinked?.map((item) => ({
            ...item,
            isDepositeGreaterThanBalanceAnother: false,
          }));
          setPlaidAccNoLinked(resetDisableCondition);
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target
              .name]: `A minimum deposit of $${fundData?.minDepositAmount} is required to open this account.`,
          }));
        }
      } else if (parseInt(e.target.value, 10) >= parseInt(fundData?.minDepositAmount, 10)) {
        setFundDataErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '',
        }));
      } else {
        setFundDataErrors((prevState) => ({
          ...prevState,
          [e.target.name]: MIN_DEPOSIT_ERR,
        }));
      }
    }
    //  else if (e.target.value?.length > 7) {
    //   maxAmountCheck(e);
    // }
    else if (e.target.value === '') {
      setFundData((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const handleChange = (e) => {
    if (dgiMapping(leadGenerationContext.productName)) {
      setIsFundingScreenDirty(true);
      setIsEdeliveryScreenDirty(true);
    } else {
      setIsFundingScreenDirty(true);
    }
    switch (e.target.name) {
      case 'depositAmount':
        depositAmountCall(e);
        break;
      case 'typeOfAccount':
        typeOfAccountCall(e);
        break;
      case 'accountNumber':
        accountNumberCall(e);
        break;
      case 'bank':
        if (e.target.value.length > 0) {
          if (e.target.value !== OTHER) {
            setFundData((prevState) => ({
              ...prevState,
              otherBank: '',
            }));
            setFundDataErrors((prevState) => ({
              ...prevState,
              otherBank: '',
            }));
          }
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
            transitNumber: '',
            customTransitNumber: '',
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: '',
            transitNumber: '',
            customTransitNumber: '',
          }));
          bankDetailsChange(e);
        } else {
          setFundData((prevState) => ({
            ...prevState,
            transitNumber: '',
            customTransitNumber: '',
            [e.target.name]: e.target.value,
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            transitNumber: '',
            customTransitNumber: '',
            [e.target.name]: MANDATORY_FIELD_ERR,
          }));
          setBankTransitNumbers([]);
        }
        break;

      case 'otherBank':
        if (e.target.value) {
          const regex = /^[ a-zA-Z0-9.,&-]{1,30}$/;
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          if (e.target.value.match(regex)) {
            setFundDataErrors((prevState) => ({
              ...prevState,
              [e.target.name]: '',
            }));
          } else {
            setFundDataErrors((prevState) => ({
              ...prevState,
              [e.target.name]: '* Invalid format',
            }));
          }
        } else if (e.target.value === '') {
          setFundData((prevState) => ({ ...prevState, [e.target.name]: '' }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: MANDATORY_FIELD_ERR,
          }));
        }
        break;

      case 'transitNumber':
        transitNumberChange(e);
        break;
      case 'customTransitNumber':
        transitNumberChange(e);
        break;

      default:
        break;
    }
  };

  const bankTransitNumbersCall = (bank) => {
    if (bank && bank.transistNumbers) {
      const transitNumbers = bank?.transistNumbers;
      if (!transitNumbers?.includes('Other')) {
        transitNumbers.push('Other');
      }
      if (transitNumbers && transitNumbers?.length > 0) {
        setBankTransitNumbers(transitNumbers);
      } else {
        setBankTransitNumbers([]);
      }
    } else {
      setBankTransitNumbers([]);
    }
  };
  useEffect(() => {
    if (cdFlowOffers?.depositAmount) {
      if (isCDproduct(productName)) {
        setFundData({
          ...fundData,
          depositAmount: cdFlowOffers?.depositAmount,
          minDepositAmount: '1000',
        });
      } else if (isCDIraproduct(productName)) {
        setFundData({
          ...fundData,
          depositAmount: productDataIRA?.depositAmount
            ? productDataIRA?.depositAmount
            : cdFlowOffers?.depositAmount,
          minDepositAmount: '250',
        });
        setIsFundingScreenDirty(true);
      }
    }
  }, []);
  useEffect(() => {
    const bankList = [];
    if (bankDetails && bankDetails?.length > 0) {
      for (const element of bankDetails) {
        bankList.push(element.bankName);
      }
    }
    setBanks(bankList);
    if (fundData?.bank) {
      if (bankDetails && bankDetails?.length > 0) {
        let bank = '';
        for (const element of bankDetails) {
          if (element.bankName === fundData?.bank) {
            bank = element;
            break;
          }
        }
        bankTransitNumbersCall(bank);
      }
    }
  }, []);

  const typeOfAccountCall = (e) => {
    if (e.target.value.length > 0) {
      setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: '',
      }));
    } else {
      setFundData((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };

  const getDataForSelectedAcc = (e) => {
    const selectedAccount = plaidAccNoLinked?.find((item) => item.Id === e);
    return selectedAccount || '';
  };
  const handleChangePlaidSuccess = (e) => {
    setIsFundingScreenDirty(true);

    const accountNumberLength = getDataForSelectedAcc(e.target.value).AccountNumber?.length;
    let conditionAccNo = accountNumberLength >= 9 && accountNumberLength <= 16;

    if (isPlaidProduct(productName)) {
      conditionAccNo = accountNumberLength >= 9 && accountNumberLength <= 17;
    }
    if (e.target.value.length > 0) {
      if (conditionAccNo) {
        if (
          fundData.depositAmount &&
          plaidDetails?.status === 'Success' &&
          fundData?.depositAmount?.replace(',', '') > getAmountByAccountNumber(e.target.value)
        ) {
          const updateAccountDetailsPlaid = plaidAccNoLinked?.map((option) => {
            let isDepositeGreaterThanBalanceAnother;

            if (fundData.accountNumber) {
              isDepositeGreaterThanBalanceAnother = option.AccountNumber === fundData.accountNumber;
            }
            return { ...option, isDepositeGreaterThanBalanceAnother };
          });
          setPlaidAccNoLinked(updateAccountDetailsPlaid);

          if (isCDIraproduct(productName) && flowTypeETB === 'EtbFlow') {
            setFundDataErrors({
              ...fundDataErrors,
              depositAmount:
                '* Please review the deposit amount entered as it is more than the available balance on this account. Return to the previous step and enter a lower amount to continue.',
            });
          } else {
            setFundDataErrors({
              ...fundDataErrors,
              depositAmount:
                '* Please review the deposit amount entered as it is more than the available balance on this account',
            });
          }
        } else {
          const resetDisableCondition = plaidAccNoLinked?.map((item) => ({
            ...item,
            isDepositeGreaterThanBalanceAnother: false,
          }));
          setPlaidAccNoLinked(resetDisableCondition);

          setFundDataErrors((prevState) => ({
            ...prevState,
            depositAmount: '',
          }));
        }
        setPlaidSuccessDetails((prevState) => ({
          ...prevState,
          accId: getDataForSelectedAcc(e.target.value).Id,
        }));
        setFundData((prevState) => ({
          ...prevState,
          Id: e.target.value,
          accountNumber: getDataForSelectedAcc(e.target.value).AccountNumber,
          maskedAccId: getDataForSelectedAcc(e.target.value).Id,
          transitNumber: getDataForSelectedAcc(e.target.value).RoutingNumber,
          typeOfAccount: getDataForSelectedAcc(e.target.value).AccountType,
          balance: getDataForSelectedAcc(e.target.value).Balance,
        }));
        setFundDataErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '',
        }));
      } else {
        setPlaidSuccessDetails((prevState) => ({
          ...prevState,
          accId: getDataForSelectedAcc(e.target.value).Id,
        }));
        setFundData((prevState) => ({
          ...prevState,
          accountNumber: getDataForSelectedAcc(e.target.value).AccountNumber,
          Id: e.target.value,
          maskedAccId: getDataForSelectedAcc(e.target.value).Id,
          transitNumber: getDataForSelectedAcc(e.target.value).RoutingNumber,
          typeOfAccount: getDataForSelectedAcc(e.target.value).AccountType,
          balance: getDataForSelectedAcc(e.target.value).Balance,
        }));
        setFundDataErrors((prevState) => ({
          ...prevState,
          accountNumber: 'Account number exceeds the maximum allowed limit',
        }));
      }
    } else {
      setFundDataErrors((prevState) => ({
        ...prevState,
        depositAmount: '',
      }));
      setPlaidSuccessDetails((prevState) => ({
        ...prevState,
        accId: '',
      }));
      setFundData((prevState) => ({
        ...prevState,
        accountNumber: '',
        Id: '',
        typeOfAccount: '',
        balance: '',
      }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const accountNumberCall = (e) => {
    const conditionAccNoSelect = isPlaidProduct(productName)
      ? e.target.value.length >= 9 && e.target.value.length <= 17
      : e.target.value.length >= 9 && e.target.value.length <= 16;
    if (e.target.value && e.target.value.match(/^\d*$/)) {
      if (conditionAccNoSelect) {
        setFundData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value,
        }));
        setFundDataErrors((prevState) => ({
          ...prevState,
          [e.target.name]: '',
        }));
        if (e.target.value.match(/^0*$/g)) {
          setFundData((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            [e.target.name]: '* Invalid Account Number',
          }));
        }
      } else {
        setFundData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value,
        }));
        setFundDataErrors((prevState) => ({
          ...prevState,
          [e.target.name]: INVALID_FORMAT_ERR,
        }));
      }
    } else if (e.target.value === '') {
      setFundData((prevState) => ({ ...prevState, [e.target.name]: '' }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const bankTransitNumbersChange = (bank) => {
    if (bank && bank.transistNumbers) {
      const transitNumbers = bank?.transistNumbers;
      if (!transitNumbers?.includes('Other')) {
        transitNumbers.push('Other');
      }
      if (transitNumbers && transitNumbers?.length > 0) {
        setBankTransitNumbers(transitNumbers);
        if (transitNumbers.length === 1 && transitNumbers[0] !== OTHER) {
          setFundData((prevState) => ({
            ...prevState,
            transitNumber: transitNumbers[0],
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
        } else {
          setFundData((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
          setFundDataErrors((prevState) => ({
            ...prevState,
            transitNumber: '',
          }));
        }
      } else {
        setBankTransitNumbers([]);
        setFundData((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
        setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else {
      setBankTransitNumbers([]);
      setFundData((prevState) => ({ ...prevState, transitNumber: '' }));
      setFundDataErrors((prevState) => ({
        ...prevState,
        transitNumber: MANDATORY_FIELD_ERR,
      }));
    }
  };
  const bankDetailsChange = (e) => {
    if (bankDetails && bankDetails?.length > 0) {
      let bank = '';
      for (const element of bankDetails) {
        if (element.bankName === e.target.value) {
          bank = element;
          break;
        }
      }
      bankTransitNumbersChange(bank);
    }
  };

  const transitNumberChange = (e) => {
    if (
      fundData?.bank === OTHER &&
      e.target.name === 'transitNumber' &&
      e.target.value.length >= 1 &&
      e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        transitNumber: e.target.value,
      }));

      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          transitNumber: '',
        }));
      }
    } else if (
      fundData?.bank !== OTHER &&
      e.target.name === 'transitNumber' &&
      e.target.value.length >= 1

      // e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        transitNumber: e.target.value,
      }));
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        transitNumber: '',
      }));
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        customTransitNumber: '',
      }));
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        customTransitNumber: '',
      }));
    } else if (
      fundData?.transitNumber === OTHER &&
      e.target.name === 'customTransitNumber' &&
      e.target.value.length >= 1 &&
      e.target.value.match(/^\d*$/)
    ) {
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        customTransitNumber: e.target.value,
      }));
      if (!e.target.value.match(/^\d*$/) || parseInt(e.target.value, 10) === 0) {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: '* Invalid Format',
        }));
      } else {
        leadGenerationContext.setFundDataErrors((prevState) => ({
          ...prevState,
          customTransitNumber: '',
        }));
      }
    } else if (e.target.value === '') {
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        [e.target.name]: MANDATORY_FIELD_ERR,
      }));
      leadGenerationContext.setFundData((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }
  };
  const handleBlur = (e) => {
    const currencyValue = e?.target?.value?.replace(/^0+/, '');
    const newCurrencyValue = nbrToCurrencyFormat(currencyValue);
    setFundData((prevState) => ({
      ...prevState,
      [e?.target?.name]: newCurrencyValue,
    }));
  };

  const handleFocus = (e) => {
    const currencyValue = e.target.value.toString().replace(/[^\w\s]/gi, '');
    setFundData((prevState) => ({
      ...prevState,
      [e.target.name]: currencyValue,
    }));
  };
  const handleAutoCompleteFunds = (name, value) => {
    // autoCompleteCommon(name, value, leadGenerationContext);
    leadGenerationContext.setIsTrustInfoDirty(true);
    leadGenerationContext.setIsFinanceInfoDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    leadGenerationContext.setIsEdeliveryScreenDirty(true);
    // leadGenerationContext.setsourceOfFunds(value);
    leadGenerationContext.setFundData((prevState) => ({
      ...prevState,
      sourceofFunds: value,
    }));
    if (!value) {
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        sourceofFunds: MANDATORY_FIELD_ERR,
      }));
    } else {
      leadGenerationContext.setFundDataErrors((prevState) => ({
        ...prevState,
        sourceofFunds: '',
      }));
    }
  };

  return (
    <>
      {plaidDetails?.status === 'Failed' ? (
        <Grid container>
          <Grid size={{ xs: 12, md: 6, sm: 6, lg: 6 }} sx={classes.paddingFailStatus}>
            <Box
              component="div"
              sx={[
                isBundle(productName) ? classes.divLayoutBundle : classes.divLayout,
                classes.successGrid,
              ]}
              style={{
                opacity:
                  plaidRetry > 2 || (statementDocumentId !== null && statementUploadStatus !== null)
                    ? '0.5'
                    : '1',
              }}
              // style={{
              //   display: 'flex',
              //   flexDirection: 'column',
              //   justifyContent: 'center',
              //   alignItems: 'flex-start',
              // }}
            >
              <img alt="progressaImgPlaid" src={FailImage} height="64px" width="64px" />
              <Typography
                sx={[
                  classes.VerificationFail,
                  classes.verfiyFailSpacing,
                  isBundle(productName) && !isLightTheme && { color: 'white' },
                ]}
              >
                {t('Verification Failed', {
                  defaultValue: 'Verification Failed',
                })}
              </Typography>
              <Typography
                sx={[
                  classes.FailtextYourAcc,
                  isBundle(productName) && !isLightTheme && { color: 'white' },
                ]}
              >
                {t(
                  'Your account verification is failed.Don’t worry you can upload your bank statement or ',
                  {
                    defaultValue:
                      'Your account verification is failed.Don’t worry you can upload your bank statement or ',
                  }
                )}
                <Button
                  type="button"
                  sx={classes.FailtextTryAgain}
                  style={{
                    cursor:
                      plaidRetry > 2 ||
                      (statementDocumentId !== null && statementUploadStatus !== null)
                        ? 'default'
                        : 'pointer',
                    background: 'transparent',
                    border: 'none',
                    '&:focus': {
                      outline: `2px solid ${RADIO_COLOR}`,
                      outlineOffset: '2px',
                    },
                  }}
                  disabled={
                    (statementDocumentId !== null && statementUploadStatus !== null) ||
                    !ready ||
                    plaidRetry > 2
                  }
                  onClick={() => open()}
                >
                  {t('Try Again', {
                    defaultValue: 'Try Again',
                  })}
                </Button>
              </Typography>
            </Box>
          </Grid>
          <Grid
            size={{ xs: 12, md: 6, sm: 6, lg: 6 }}
            role="application"
            aria-roledescription={t(FUND_UPLOAD_VOID_CHECK, {
              defaultValue: FUND_UPLOAD_VOID_CHECK,
            })}
            sx={classes.statementUploadPadding}
            aria-describedby="uploadVoid"
          >
            <StatementUpload
              fileType="Check Or Bank Statement"
              pagePath="funding-info"
              isBundle={isBundle(productName)}
            />
          </Grid>
        </Grid>
      ) : isVerificationPending && !isBundle(productName) ? (
        ' '
      ) : (
        <Grid container width="100%">
          <Grid item container width="100%" spacing={2}>
            {(!isPlaidSuccess || isBundle(productName)) && (
              <Grid
                size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
                sx={
                  (statementDocumentId !== null && statementUploadStatus === 'DONE') ||
                  isPlaidSuccess ||
                  isVerificationPending ||
                  statementUploadLoading ||
                  !ready
                    ? classes.cardDisabel
                    : classes.cardEnable
                }
              >
                <Box
                  component="div"
                  sx={[
                    {
                      ...classes.successGrid,
                      '@media (max-width:600px)': {
                        marginTop: '0px',
                      },
                    },
                    isBundle(productName) ? classes.divLayoutBundle : classes.divLayout,
                    {
                      backgroundColor: isBundle(productName)
                        ? theme?.palette?.plaidCardBg?.main
                        : '#F8F8F8',
                      border: isBundle(productName)
                        ? `1px solid ${theme?.palette?.plaidCardBorder?.main}`
                        : '1px solid #D0D0D0',
                      borderRadius: isBundle(productName) ? '24px' : '4px',
                    },
                    isBundle(productName) && { padding: '24px !important' },
                  ]}
                >
                  <Box
                    component="div"
                    sx={
                      isBundle(productName)
                        ? classes.bundleWeRecommendText
                        : [classes.weRecommendTextPadding, classes.weRecommendTextStyle]
                    }
                    id="recommend"
                  >
                    {isBundle(productName) ? (
                      <Box component="span" sx={{ display: 'flex' }}>
                        <Typography component="p">
                          <ThumbsUpWhite />
                        </Typography>
                        &ensp;
                        <Typography
                          component="p"
                          sx={{ fontSize: '12px', fontWeight: 700, color: '#FFF' }}
                        >
                          {t('WE RECOMMEND', { defaultValue: 'WE RECOMMEND' })}
                        </Typography>
                      </Box>
                    ) : (
                      <Box component="span" sx={classes.text}>
                        {t('WE RECOMMEND', { defaultValue: 'WE RECOMMEND' })}
                      </Box>
                    )}
                  </Box>
                  {isLightTheme ? (
                    <img alt="progressaImgPlaid" src={PlaidImage} height="42px" width="111px" />
                  ) : (
                    <img alt="progressaImgPlaid" src={PlaidImageDark} height="42px" width="111px" />
                  )}
                  <Typography
                    variant="h5"
                    component="h5"
                    sx={[isBundle(productName) ? classes.textVerifyBundle : classes.textVerify]}
                    id="desc1"
                  >
                    {t('Verify with Plaid', {
                      defaultValue: 'Verify with Plaid',
                    })}
                  </Typography>
                  <Typography
                    sx={
                      isBundle(productName)
                        ? classes.bundletextverifysubhead
                        : classes.textverifySubHead
                    }
                    color="subtext"
                    variant={isBundle(productName) ? 'body1' : 'subtitle1'}
                    component="p"
                    id="desc2"
                  >
                    {isBundle(productName)
                      ? t('Deposit with another account (via Plaid)', {
                          defaultValue: 'Deposit with another account (via Plaid)',
                        })
                      : t('It can help you control access to your data.', {
                          defaultValue: 'It can help you control access to your data.',
                        })}
                  </Typography>

                  <Button
                    disableFocusRipple
                    disabled={
                      (statementDocumentId !== null && statementUploadStatus === 'DONE') ||
                      isPlaidSuccess ||
                      isVerificationPending ||
                      statementUploadLoading ||
                      !ready
                    }
                    onClick={() => open()}
                    classes={{
                      disabled: classes.next_disabled_button,
                    }}
                    sx={{
                      ...(isBundle(productName)
                        ? classes.next_continue_button_bundle
                        : classes.next_continue_button),
                      border: `1px solid ${theme?.palette?.orientalPrimary?.main}`,
                      background: `${theme?.palette?.orientalPrimary?.main} 0% 0% no-repeat padding-box`,
                      ':hover': {
                        backgroundColor: theme?.palette?.orientalPrimary?.main,
                      },
                      ':focus': {
                        outline: `2px solid ${theme?.palette?.orientalPrimary?.main}`,
                        outlineOffset: '2px',
                      },
                      '&.MuiButton-root.Mui-disabled': {
                        background: isBundle(productName)
                          ? theme?.palette?.disabledButtonBackground?.main
                          : '#661C69',
                        borderRadius: '56px',
                        color: isBundle(productName)
                          ? theme?.palette?.disabledButton?.main
                          : '#FFFFFF',
                        border: 'none',
                      },
                    }}
                    data-testid="verfy-now-id"
                    aria-describedby="recommend desc1 desc2"
                  >
                    {t('Verify Now', {
                      defaultValue: 'Verify Now',
                      nsSeparator: '|',
                    })}
                  </Button>
                </Box>
              </Grid>
            )}
            {(!isPlaidSuccess || isBundle(productName)) && (
              <Grid
                size={{ xs: 12, sm: 12, md: 6, lg: 6 }}
                sx={
                  isBundle(productName) &&
                  ((statementDocumentId !== null && statementUploadStatus === 'DONE') ||
                    isPlaidSuccess ||
                    isVerificationPending)
                    ? classes.cardDisabel
                    : [classes.cardEnable, classes.statementUploadPadding]
                }
                cardDisabel
              >
                <StatementUpload
                  fileType="Check Or Bank Statement"
                  pagePath="funding-info"
                  isBundle={isBundle(productName)}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      )}

      {/* )} */}
      {isVerificationPending && !isBundle(productName) && (
        <Grid container>
          <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={classes.pendingContainer}>
            <Box
              component="div"
              style={{ maxHeight: '100%' }}
              sx={[
                isBundle(productName) ? classes.divLayoutBundle : classes.divLayout,
                classes.successGrid,
              ]}
            >
              <img alt="progressaImgPlaid" src={PendingImage} height="64px" width="64px" />
              <Typography sx={[classes.VerificationFail, classes.VerificationFailSpacing]}>
                {t('Verification Pending', {
                  defaultValue: 'Verification Pending',
                })}
              </Typography>
              <Typography sx={classes.FailtextYourAcc}>
                {t(
                  'Your account verification is pending. We will send you an email to validate the microdeposits. However, you must complete the application so we can finalize the account verification.',
                  {
                    defaultValue:
                      'Your account verification is pending. We will send you an email to validate the microdeposits. However, you must complete the application so we can finalize the account verification.',
                  }
                )}
              </Typography>
            </Box>
          </Grid>
        </Grid>
      )}
      {isVerificationPending && isBundle(productName) && (
        <Grid
          container
          spacing={2}
          sx={{
            ...bundleClasses.verificationPendingContainer,
            backgroundColor: theme?.palette?.warningBackground?.main,
          }}
        >
          <Grid size={{ md: 1 }} sx={bundleClasses.verificationPending}>
            <VerificationPendingIcon />
          </Grid>
          <Grid size={{ md: 11 }}>
            <Typography
              component="h5"
              variant="h5"
              marginBottom="10px"
              sx={bundleClasses.verificationPendingHeading}
            >
              {t(VERIFICATION_INPROGRESS, {
                defaultValue: VERIFICATION_INPROGRESS,
              })}
            </Typography>
            <Typography component="p" variant="subtitle2">
              {t(VERIFICATION_PENDING, {
                defaultValue: VERIFICATION_PENDING,
              })}
            </Typography>
          </Grid>
        </Grid>
      )}
      {/* Plaid Success old layout */}
      {isPlaidSuccess && !isBundle(productName) && (
        <Grid
          container
          style={{ maxHeight: '100%' }}
          sx={[
            isBundle(productName) ? classes.divLayoutBundle : classes.divLayout,
            classes.gridPadding,
          ]}
        >
          <Grid size={{ xs: 12, md: isMobile ? 5 : 6 }} sx={classes.successGridPadding}>
            <Box component="div" sx={classes.successGrid}>
              <img alt="progressaImgPlaid" src={SuccessImage} height="64px" width="64px" />
              <Typography sx={[classes.VerificationFail, classes.allSettextMargin]}>
                {t('You’re all set!', {
                  defaultValue: 'You’re all set!',
                })}
              </Typography>
              <Typography sx={classes.FailtextYourAcc}>
                {t('We have verified the details of the bank account, and you’re good to go.', {
                  defaultValue:
                    'We have verified the details of the bank account, and you’re good to go.',
                })}
              </Typography>
            </Box>
          </Grid>
          <Grid size={{ xs: 12, md: isMobile ? 7 : 6 }} sx={classes.accountInfopadding}>
            <Typography sx={classes.accountInfo}>
              {t('Account information', {
                defaultValue: 'Account information',
              })}
            </Typography>
            <Grid container sx={classes.accountInfoGrid} spacing={1}>
              <Grid size={{ xs: 12, md: 12, lg: 12 }} sx={classes.paddingSuccess}>
                <>
                  <CustomSelectAccount
                    id="accountNumber"
                    disabled={singleAccDis}
                    isBundle={isBundle(productName)}
                    dataTestId="accountNo_id"
                    inputLabelAriaLabel={`${t('Account Number', {
                      defaultValue: 'Account Number',
                    })}`}
                    label={t('Account Number', { defaultValue: 'Account Number' })}
                    options={plaidAccNoLinked}
                    handleChange={handleChangePlaidSuccess}
                    fullWidth
                    inputProps={{
                      maxLength: isPlaidProduct(productName) ? 17 : 16,
                      'data-testid': 'account-number',
                      inputMode: 'numeric',
                    }}
                    value={commonUtility(fundData?.Id)}
                    error={fundDataErrors?.accountNumber}
                    selectAriaLabel={`${t('Aria Label Type Of Account', {
                      defaultValue:
                        'Account No Required Select Type Of Account dropdown menu button',
                    })}`}
                  />
                  <Box
                    component="span"
                    style={{ marginTop: '10px' }}
                    role="alert"
                    sx={classes.error_message}
                  >
                    {t(fundDataErrors?.accountNumber, {
                      defaultValue: fundDataErrors?.accountNumber,
                    })}
                  </Box>
                </>
              </Grid>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  width: '100%',
                  paddingLeft: '3px',
                }}
              >
                <Grid
                  size={{ xs: 12, md: gridSizeForBundle, lg: gridSizeForBundle }}
                  sx={classes.paddingSuccessAccType}
                >
                  {fundData.accountNumber !== '' && (
                    <>
                      <Typography sx={[classes.labelStyle, classes.menuItemMargin]}>
                        {t('Account Type', {
                          defaultValue: 'Account Type',
                        })}
                      </Typography>
                      <Typography sx={classes.labelValueStyle}>
                        {t(fundData.typeOfAccount, {
                          defaultValue: fundData.typeOfAccount,
                        })}
                      </Typography>
                    </>
                  )}
                </Grid>
                <Grid size={{ xs: 12, md: gridSizeForBundle, lg: gridSizeForBundle }}>
                  {fundData.accountNumber !== '' && (
                    <>
                      <Typography sx={[classes.labelStyle, classes.menuItemMargin]}>
                        {t('Routing Number', {
                          defaultValue: 'Routing Number',
                        })}
                      </Typography>
                      <Typography sx={classes.labelValueStyle}>
                        {t(fundData.transitNumber, {
                          defaultValue: fundData.transitNumber,
                        })}
                      </Typography>
                    </>
                  )}
                </Grid>
              </div>
            </Grid>
          </Grid>
        </Grid>
      )}
      {isPlaidSuccess && isBundle(productName) && (
        <Grid
          container
          spacing={2}
          sx={{
            ...bundleClasses.plaidSucessContainer,
            backgroundColor: theme?.palette?.successBackground?.main,
          }}
        >
          <Grid size={{ md: 1 }} sx={bundleClasses.verificationPending}>
            <GreenTickFill />
          </Grid>
          <Grid size={{ md: 11 }}>
            <Typography
              component="h5"
              variant="h5"
              marginBottom="10px"
              sx={bundleClasses.verificationPendingHeading}
            >
              {t('Verification successful', {
                defaultValue: 'Verification successful',
              })}
            </Typography>
            <Typography variant="subtitle2" component="p">
              {t('We have verified your bank account details, and you are ready to begin.', {
                defaultValue:
                  'We have verified your bank account details, and you are ready to begin.',
              })}
            </Typography>
          </Grid>
        </Grid>
      )}
      {/* <BusinessDragDropUploadACT /> */}
      {isBundle(productName) && (
        <Grid container paddingY="30px" width="100%">
          <Grid
            size={{ md: 12, lg: 12, sm: 12, xs: 12 }}
            sx={{
              backgroundColor: isLightTheme
                ? '#FFFFFF'
                : statementUploadStatus === 'FAILED'
                ? 'rgba(255, 105, 113, 0.2)'
                : statementUploadStatus === 'DONE' && statementUploadLoading
                ? 'rgba(11, 108, 3, 0.2)'
                : theme?.palette?.fieldsBorder?.main,
              border: `1px solid ${theme?.palette?.fieldsBorder?.main} !important`,
              color: theme?.palette?.primary?.main,
              borderRadius: '6px',
            }}
          >
            <LinearWithValueLabel fileType="Check Or Bank Statement" pagePath="funding-info" />
          </Grid>
        </Grid>
      )}

      <Grid
        container
        size={{ md: 12 }}
        spacing={2}
        style={{ width: '100%' }}
        sx={
          !isBundle(productName)
            ? statementDocumentId !== null && statementUploadStatus !== null
              ? [classes.depositeSpacing, classes.field_padding_right]
              : plaidDetails?.remarks === 'pending_manual_verification' &&
                plaidDetails?.status === 'Success'
              ? [classes.depositeSpacingBorder, classes.field_padding_right]
              : [classes.depositeSpacingBorderOther, classes.field_padding_right]
            : ''
        }
      >
        {isPlaidSuccess && isBundle(productName) && (
          <Grid size={{ xs: 12, md: gridSizeForBundle, lg: gridSizeForBundle }}>
            <CustomSelectAccount
              id="accountNumber"
              isBundle={isBundle(productName)}
              disabled={singleAccDis}
              dataTestId="accountNo_id"
              inputLabelAriaLabel={`${t('Account Number', {
                defaultValue: 'Account Number',
              })}`}
              label={t('Account Number', { defaultValue: 'Account Number' })}
              options={plaidAccNoLinked}
              handleChange={handleChangePlaidSuccess}
              fullWidth
              inputProps={{
                maxLength: isPlaidProduct(productName) ? 17 : 16,
                'data-testid': 'account-number',
                inputMode: 'numeric',
              }}
              value={commonUtility(fundData?.Id)}
              error={fundDataErrors?.accountNumber}
              selectAriaLabel={`${t('Aria Label Type Of Account', {
                defaultValue: 'Account No Required Select Type Of Account dropdown menu button',
              })}`}
              flow={productName}
            />
            <Box
              component="span"
              style={{ marginTop: '10px' }}
              role="alert"
              sx={classes.error_message}
            >
              {t(fundDataErrors?.accountNumber, {
                defaultValue: fundDataErrors?.accountNumber,
              })}
            </Box>
          </Grid>
        )}
        <Grid size={{ xs: 12, md: gridSizeForBundle, lg: gridSizeForBundle }}>
          <CustomInput
            id="depositAmount"
            dataTestId="depositAmount_id"
            required={!isBundle(productName)}
            isBundle={isBundle(productName)}
            autoFocus
            inputLabelAriaLabel={`${t(DEPOSIT_AMOUNT, {
              defaultValue: DEPOSIT_AMOUNT,
            })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
            // label={t(DEPOSIT_AMOUNT, { defaultValue: DEPOSIT_AMOUNT })}
            label={
              <span
                style={{
                  color: isBundle(productName) && fundDataErrors?.depositAmount ? 'red' : 'inherit',
                }}
              >
                {t(isBundle(productName) ? 'DEPOSIT_AMOUNT_BUNDLE' : DEPOSIT_AMOUNT)}
              </span>
            }
            handleChange={handleChange}
            handleBlur={handleBlur}
            handleFocus={handleFocus}
            disabled={
              fundData?.depositAmount && (isCDproduct(productName) || isCDIraproduct(productName))
            }
            placeholder={`${t('Minimum deposit Prog', {
              defaultValue: MINIMUM_DEPOSIT,
            })} $${fundData?.minDepositAmount}.00`}
            fullWidth
            inputProps={{
              'data-testid': 'deposit-amount',
              maxLength: 7,
              inputMode: 'numeric',
            }}
            value={commonUtilityValueReturn(fundData?.depositAmount, fundData?.depositAmount, '')}
            error={commonUtility(fundDataErrors?.depositAmount)}
          />
          <Box
            component="span"
            sx={classes.error_message}
            role="alert"
            data-testid="deposit-amount-error"
          >
            {fundDataErrors?.depositAmount === MIN_DEPOSIT_ERR && fundData.minDepositAmount
              ? `${t(fundDataErrors?.depositAmount, {
                  defaultValue: fundDataErrors?.depositAmount,
                })}${fundData?.minDepositAmount}`
              : t(fundDataErrors?.depositAmount, {
                  defaultValue: fundDataErrors?.depositAmount,
                })}
          </Box>
        </Grid>
        {/* {isCDproduct(productName) && ( */}
        <Grid size={{ xs: 12, md: gridSizeForBundle }}>
          <InputLabel
            htmlFor="sourceOfFunds"
            required={!isBundle(productName)}
            id="sourceOfFunds_label"
            data-testid="sourceOfFunds_testid"
            aria-label={`${t(SOURCE_OF_FUNDS, { defaultValue: SOURCE_OF_FUNDS })} ${t(REQUIRED, {
              defaultValue: REQUIRED,
            })}`}
            sx={commonClass.label_title}
          >
            <span
              style={{
                color:
                  isBundle(productName) && leadGenerationContext.fundDataErrors?.sourceofFunds
                    ? 'red'
                    : 'inherit',
              }}
            >
              {t(SOURCE_OF_FUNDS, { defaultValue: SOURCE_OF_FUNDS })}
            </span>
          </InputLabel>
          <Autocomplete
            id="sourceOfFunds"
            data-testid="autocomplete"
            name="sourceOfFunds"
            options={SourceOfFundsList}
            getOptionLabel={(option) => {
              if (!option || typeof option !== 'object') return '';
              return language === EN ? option.en || '' : option.es || '';
            }}
            value={leadGenerationContext.fundData.sourceofFunds}
            // sourceofFunds, setsourceOfFunds
            // value={commonFunction(sourceofFunds)}
            // value={leadGenerationContext.fundData.sourceofFunds || null}
            // getOptionSelected={(option, value) => option.value === value.value || ''}
            onChange={(_event, selectedValue) => {
              handleAutoCompleteFunds('sourceOfFunds', selectedValue);
            }}
            renderInput={(params) => (
              <OutlinedInput
                id="sourceOfFunds"
                name="sourceOfFunds"
                inputProps={{
                  ...params.inputProps,
                  style: { fontSize: '16px' },
                }}
                ref={params.InputProps.ref}
                endAdornment={
                  (isBundle(productName) || isCDIraproduct(productName)) && (
                    <Box padding="0 10px 0 0">
                      <DownArrowIcon
                        style={{ width: 24, height: 24 }}
                        color={theme?.palette?.orientalPrimary?.main}
                      />
                    </Box>
                  )
                }
                slotProps={{
                  notchedOutline: {
                    sx: !leadGenerationContext.fundDataErrors.sourceofFunds
                      ? commonClass.notchedOutline
                      : commonClass.notchedOutlineErr,
                  },
                  input: {
                    sx: isBundle(productName)
                      ? {
                          padding: '14px 14px 10px 14px !important',
                          '@media (max-width: 430px)': {
                            padding: '14px 0px 10px 14px !important',
                          },
                        }
                      : {},
                  },
                  paper: {
                    sx: {
                      backgroundColor: theme?.menuBackground,
                      color: theme?.palette?.primary?.main,
                      padding: '14px 14px 10px 14px',
                    },
                  },
                }}
                sx={[
                  commonClass.outlined_inputs,
                  {
                    '&::placeholder': {
                      fontSize: '16px',
                    },
                  },
                  ...(isBundle(productName)
                    ? [
                        {
                          '&.Mui-focused': {
                            border: `1px solid ${theme?.palette?.primary?.main}`,
                          },
                        },
                        commonClass.customBorderRadius,
                        commonClass.outlined_input_bundle,
                        {
                          borderRadius: '50px',
                          backgroundColor: leadGenerationContext.fundDataErrors.sourceofFunds
                            ? '#D5151F1A'
                            : theme?.palette?.fieldsBackground?.main,
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderRadius: '50px',
                            borderColor: leadGenerationContext.fundDataErrors.sourceofFunds
                              ? 'red'
                              : theme?.palette?.primary?.main,
                          },
                          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: leadGenerationContext.fundDataErrors.sourceofFunds
                              ? 'red'
                              : theme?.palette?.primary?.main,
                          },
                        },
                      ]
                    : [
                        { paddingRight: '9px !important' },
                        {
                          '&.Mui-focused': {
                            border: `1px solid ${theme?.palette?.primary?.main}`,
                          },
                        },
                      ]),
                ]}
                placeholder={t(SOURCE_OF_FUNDS_PLACEHOLDER, {
                  defaultValue: SOURCE_OF_FUNDS_PLACEHOLDER,
                })}
                fullWidth
                // value={leadGenerationContext.fundData.sourceofFunds}
              />
            )}
            filterOptions={filterOptionsEmp}
            slotProps={{
              paper: {
                sx: {
                  backgroundColor: theme?.menuBackground,
                  color: theme?.palette?.primary?.main,
                },
              },
            }}
          />
          <Box
            component="span"
            sx={commonClass.error_message_product}
            data-testid="sourceOFFundsErr-id"
            role="alert"
          >
            {t(leadGenerationContext.fundDataErrors.sourceofFunds, {
              defaultValue: leadGenerationContext.fundDataErrors.sourceofFunds,
            })}
          </Box>
        </Grid>
        {/* )} */}
      </Grid>
      {statementDocumentId !== null &&
        statementUploadStatus !== null &&
        isPlaidProduct(productName) && (
          <>
            <Grid
              container
              size={{ md: 12, sm: 12, xs: 12 }}
              sx={[classes.inputs_grid_margin_another]}
            >
              <Grid size={{ xs: 12, md: gridSizeForBundle }}>
                <CustomSelect
                  id="typeOfAccount"
                  dataTestId="typeOfAccount_id"
                  required={!isBundle(productName)}
                  isBundle={isBundle(productName)}
                  inputLabelAriaLabel={`${t(
                    isBundle(productName) ? ACCOUNT_TYPE : TYPE_OF_ACCOUNT,
                    {
                      defaultValue: isBundle(productName) ? ACCOUNT_TYPE : TYPE_OF_ACCOUNT,
                    }
                  )}`}
                  label={
                    <span
                      style={{
                        color:
                          isBundle(productName) && fundDataErrors?.typeOfAccount
                            ? 'red'
                            : 'inherit',
                      }}
                    >
                      {t(isBundle(productName) ? ACCOUNT_TYPE : TYPE_OF_ACCOUNT, {
                        defaultValue: isBundle(productName) ? ACCOUNT_TYPE : TYPE_OF_ACCOUNT,
                      })}
                    </span>
                  }
                  options={['Checking', 'Savings']}
                  nsSeparator="|"
                  handleChange={handleChange}
                  fullWidth
                  value={fundData?.typeOfAccount ? fundData?.typeOfAccount : ''}
                  error={fundDataErrors?.typeOfAccount}
                  selectAriaLabel={`${t('Aria Label Type Of Account', {
                    defaultValue:
                      'Type Of Account Required Select Type Of Account dropdown menu button',
                  })}`}
                />
                <Box component="span" role="alert" sx={classes.error_message}>
                  {t(fundDataErrors?.typeOfAccount, {
                    defaultValue: fundDataErrors?.typeOfAccount,
                  })}
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              size={{ md: 12, sm: 12, xs: 12 }}
              sx={[classes.inputs_grid_margin_another, fieldRightPadding]}
            >
              <Grid size={{ xs: 12, md: gridSizeForBundle }}>
                <CustomInput
                  id="accountNumber"
                  dataTestId="accountNumber_id"
                  required={!isBundle(productName)}
                  isBundle={isBundle(productName)}
                  inputLabelAriaLabel={`${t(isBundle(productName) ? ACCOUNT_NUM : ACCOUNT_NUMBER, {
                    defaultValue: isBundle(productName) ? ACCOUNT_NUM : ACCOUNT_NUMBER,
                  })} ${t(REQUIRED, { defaultValue: REQUIRED })}`}
                  label={
                    <span
                      style={{
                        color:
                          isBundle(productName) && fundDataErrors?.accountNumber
                            ? 'red'
                            : 'inherit',
                      }}
                    >
                      {t(isBundle(productName) ? ACCOUNT_NUM : ACCOUNT_NUMBER, {
                        defaultValue: isBundle(productName) ? ACCOUNT_NUM : ACCOUNT_NUMBER,
                      })}
                    </span>
                  }
                  handleChange={handleChange}
                  placeholder={t(ENTER_ACCOUNT_NUMBER, {
                    defaultValue: ENTER_ACCOUNT_NUMBER,
                  })}
                  fullWidth
                  inputProps={{
                    maxLength: isPlaidProduct(productName) ? 17 : 16,
                    'data-testid': 'account-number',
                    inputMode: 'numeric',
                  }}
                  value={fundData?.accountNumber ? fundData.accountNumber : ''}
                  error={fundDataErrors?.accountNumber ? fundDataErrors.accountNumber : ''}
                />
                <Box
                  component="span"
                  sx={classes.error_message}
                  role="alert"
                  data-testid="account-number-error"
                >
                  {t(fundDataErrors?.accountNumber, {
                    defaultValue: fundDataErrors?.accountNumber,
                  })}
                </Box>
              </Grid>
            </Grid>

            <Grid
              container
              size={{ md: 12, sm: 12, xs: 12 }}
              sx={[classes.inputs_grid_margin_another, fieldRightPadding]}
            >
              <Grid size={{ xs: 12, md: gridSizeForBundle }}>
                <CustomSelect
                  id="bank"
                  dataTestId="bank_id"
                  required={!isBundle(productName)}
                  isBundle={isBundle(productName)}
                  inputLabelAriaLabel={`${t(BANK, { defaultValue: BANK })} `}
                  label={
                    <span
                      style={{
                        color: isBundle(productName) && fundDataErrors?.bank ? 'red' : 'inherit',
                      }}
                    >
                      {t(BANK, { defaultValue: BANK })}
                    </span>
                  }
                  options={banks}
                  nsSeparator="|"
                  handleChange={handleChange}
                  fullWidth
                  value={commonUtility(fundData?.bank)}
                  error={fundDataErrors?.bank}
                  selectAriaLabel={`${t('Aria Label Bank', {
                    defaultValue: 'Bank Required Select Bank dropdown menu button',
                  })}`}
                />
                <Box component="span" role="alert" sx={classes.error_message}>
                  {t(fundDataErrors?.bank, {
                    defaultValue: fundDataErrors?.bank,
                  })}
                </Box>
              </Grid>
            </Grid>
            {fundData?.bank === OTHER ? (
              <Grid
                container
                size={{ md: 12, sm: 12, xs: 12 }}
                sx={[classes.inputs_grid_margin_another, fieldRightPadding]}
              >
                <Grid size={{ xs: 12, md: gridSizeForBundle }}>
                  <CustomInput
                    id="otherBank"
                    dataTestId="otherBank_id"
                    required={!isBundle(productName)}
                    isBundle={isBundle(productName)}
                    inputLabelAriaLabel={`${t(BANK_NAME, { defaultValue: BANK_NAME })} ${t(
                      REQUIRED,
                      {
                        defaultValue: REQUIRED,
                      }
                    )}`}
                    label={t(BANK_NAME, { defaultValue: BANK_NAME })}
                    handleChange={handleChange}
                    placeholder={t('Enter Bank name', {
                      defaultValue: 'Enter Bank name',
                    })}
                    fullWidth
                    inputProps={{ 'data-testid': 'Other_bank', maxLength: 30 }}
                    value={commonUtility(fundData?.otherBank)}
                    error={commonUtility(fundDataErrors?.otherBank)}
                  />
                  <Box
                    component="span"
                    sx={classes.error_message}
                    role="alert"
                    data-testid="otherBank-error"
                  >
                    {t(fundDataErrors?.otherBank, {
                      defaultValue: fundDataErrors?.otherBank,
                    })}
                  </Box>
                </Grid>
              </Grid>
            ) : (
              ''
            )}
            <Grid
              container
              size={{ md: 12, sm: 12, xs: 12 }}
              sx={[fieldRightPadding, classes.transistStyle]}
            >
              <Grid size={{ xs: 12, md: gridSizeForBundle }}>
                {bankTransitNumbers && bankTransitNumbers.length > 1 ? (
                  <CustomSelect
                    id="transitNumber"
                    dataTestId="transitNumber_id"
                    required={!isBundle(productName)}
                    isBundle={isBundle(productName)}
                    inputLabelAriaLabel={`${t(
                      isBundle(productName) ? ROUTING_NUMBER : TRANSIT_NUMBER,
                      {
                        defaultValue: isBundle(productName) ? ROUTING_NUMBER : TRANSIT_NUMBER,
                      }
                    )}`}
                    label={
                      <span
                        style={{
                          color:
                            isBundle(productName) && fundDataErrors?.transitNumber
                              ? 'red'
                              : 'inherit',
                        }}
                      >
                        {t(isBundle(productName) ? 'ROUTING_BUNDLE' : TRANSIT_NUMBER)}
                      </span>
                    }
                    handleChange={handleChange}
                    options={bankTransitNumbers}
                    nsSeparator="|"
                    fullWidth
                    value={commonUtility(fundData?.transitNumber)}
                    error={fundDataErrors?.transitNumber}
                    selectAriaLabel={`${t('Aria Label Transit', {
                      defaultValue:
                        'Transit Number Required Select Transit Number dropdown menu button',
                    })}`}
                  />
                ) : (
                  <CustomInput
                    id="transitNumber"
                    disabled={
                      bankTransitNumbers &&
                      bankTransitNumbers.length === 1 &&
                      bankTransitNumbers[0] !== OTHER &&
                      isPlaidProduct(leadGenerationContext.productName)
                    }
                    dataTestId="transitNumber_id"
                    required={!isBundle(productName)}
                    isBundle={isBundle(productName)}
                    inputLabelAriaLabel={`${t(
                      isBundle(productName) ? ROUTING_NUMBER : TRANSIT_NUMBER,
                      {
                        defaultValue: isBundle(productName) ? ROUTING_NUMBER : TRANSIT_NUMBER,
                      }
                    )}`}
                    label={
                      <span
                        style={{
                          color:
                            isBundle(productName) && fundDataErrors?.transitNumber
                              ? 'red'
                              : 'inherit',
                        }}
                      >
                        {t(isBundle(productName) ? 'ROUTING_BUNDLE' : TRANSIT_NUMBER)}
                      </span>
                    }
                    handleChange={handleChange}
                    handleBlur={handleBlurRouting}
                    placeholder={commonTernary(
                      language === EN,
                      isBundle(productName)
                        ? t(ENTER_ROUTING_NUMBER, {
                            defaultValue: 'Enter Route & Transit Number',
                          })
                        : t(ENTER_ROUTING_NUMBER, { defaultValue: 'Enter Routing Number' }),
                      isBundle(productName)
                        ? t('Entrar número de ruta y tránsito', {
                            defaultValue: 'Entrar número de ruta y tránsito',
                          })
                        : t('Ingresa Número de ruta', { defaultValue: 'Ingresa Número de ruta' })
                    )}
                    fullWidth
                    inputProps={{
                      maxLength: fundData?.bank === OTHER ? 9 : 25,
                      'data-testid': 'route-and-transit-number',
                      inputMode: 'numeric',
                    }}
                    value={commonUtility(fundData?.transitNumber)}
                    error={commonUtility(fundDataErrors?.transitNumber)}
                  />
                )}

                <Box
                  component="span"
                  sx={classes.error_message}
                  role="alert"
                  data-testid="route-and-transit-number-error"
                >
                  {t(fundDataErrors?.transitNumber, {
                    defaultValue: fundDataErrors?.transitNumber,
                  })}
                </Box>
              </Grid>
              {fundData?.transitNumber === 'Other' && (
                <Grid
                  container
                  size={{ md: 12, sm: 12, xs: 12 }}
                  sx={[classes.inputs_grid_margin_another, fieldRightPadding]}
                >
                  <Grid size={{ xs: 12, md: gridSizeForBundle }}>
                    <CustomInput
                      id="customTransitNumber"
                      // disabled={
                      //   bankTransitNumbers &&
                      //   bankTransitNumbers.length === 1 &&
                      //   isPlaidProduct(leadGenerationContext.productName)
                      // }
                      dataTestId="custom_transitNumber_id"
                      required={!isBundle(productName)}
                      isBundle={isBundle(productName)}
                      inputLabelAriaLabel={`${t(ENTER_TRANSIT_NUMBER, {
                        defaultValue: ENTER_TRANSIT_NUMBER,
                      })}${t(REQUIRED, {
                        defaultValue: REQUIRED,
                      })}`}
                      label={t(ENTER_TRANSIT_NUMBER, { defaultValue: ENTER_TRANSIT_NUMBER })}
                      handleChange={handleChange}
                      handleBlur={handleBlurRouting}
                      placeholder={t('Enter Route & Transit Number', {
                        defaultValue: 'Enter Route & Transit Number',
                      })}
                      fullWidth
                      inputProps={{
                        maxLength: fundData?.transitNumber === OTHER ? 9 : 25,
                        'data-testid': 'route-and-transit-number',
                        inputMode: 'numeric',
                      }}
                      value={commonUtility(fundData?.customTransitNumber)}
                      error={commonUtility(fundDataErrors?.customTransitNumber)}
                    />
                    <Box
                      component="span"
                      sx={classes.error_message}
                      role="alert"
                      data-testid="route-and-transit-number-error"
                    >
                      {t(fundDataErrors?.customTransitNumber, {
                        defaultValue: fundDataErrors?.customTransitNumber,
                      })}
                    </Box>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </>
        )}
    </>
  );
};

export default AnotherBankAccountPlaid;
